import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { AppLabel } from "../../../../shared/components/AppLabel";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { setAssistantValue } from "../../redux/slice";
import { AssistantDatabaseBlock } from "./Components/AssistantDatabaseBlock";
import { useUpdateStorageValue } from "../../../../app/state/storageObjectSlice/hook/use-update-storage-value";
import { RenameObjectInput } from "../../../../common/RenameObjectInput";
import { InstructionBlock } from "./Components/InstructionBlock";
import { AssistantModelSelect } from "./Components/AssistantModelSelect";
import { TemperatureSlider } from "./Components/TemperatureSlider";
import { GeneratePromptModal } from "../AssistantModals/GeneratePromptModal";
import { HeaderSettingsBlock } from "./Components/HeaderSettingsBlock";
import { AssistantFunctionBlock } from "./Components/AssistantFunctionBlock";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { selectAssistantValue } from "../../redux/selectors";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { getUpdatedValue } from "../../helpers/getUpdatedValue";
import { AgentModeSwitcher } from "./Components/AgentModeSwitcher";
import { AgentAssistantsModal } from "../AssistantModals/AgentAssistantsModal";
import { SparksIcon } from "../../../../shared/icons/SparksIcon";
import { AppButton } from "../../../../shared/components/AppButton";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";

export const AssistantSettings = () => {
  const assistantValue = useAppSelector(selectAssistantValue);
  const { selectedObject } = useStorageSelectors("assistants");
  const { saveValue } = useUpdateStorageValue("assistants", setAssistantValue);
  const { handleOpenModal, handleCloseModal } = useAppModals();
  const { t } = useTranslation();

  const handleNameChange = (name: string) => {
    if (!assistantValue) return;
    const updatedValue = getUpdatedValue(assistantValue, {
      name: name,
    });
    saveValue(updatedValue, true, name);
  };

  return (
    <div
      className={classNames(
        styles.layout,
        !selectedObject?.write && styles.disabled,
      )}
    >
      <div className={styles["top-container"]}>
        <AppUnderlinedTitle
          className={styles.title}
          leftContent={t("assistants.instruction")}
        >
          <AgentModeSwitcher openAttachAssistantsModal={handleOpenModal} />
        </AppUnderlinedTitle>
        <HeaderSettingsBlock />
        <RenameObjectInput
          service={"assistants"}
          handleChangeName={handleNameChange}
          inputType={"input"}
        />
        <InstructionBlock
          saveAssistant={saveValue}
          handleOpenModal={handleOpenModal}
          hasGeneratePromptModal
        />
        <AppButton
          disabled={!assistantValue?.meta?.agent_mode}
          buttonType={"outlined"}
          onClick={() => handleOpenModal("agent_assistants_modal", null)}
          icon={<SparksIcon />}
          className={styles["connected-btn"]}
        >
          {t("agents.modal_button")}
        </AppButton>
        <div className={styles["select-container"]}>
          <AppLabel className={styles.text}>
            {t("assistants.select_model_label")}
          </AppLabel>
          <div className={styles["models-container"]}>
            <AssistantModelSelect saveAssistant={saveValue} />
          </div>
          <AssistantDatabaseBlock
            saveAssistant={saveValue}
            openDatabaseModal={handleOpenModal}
          />
        </div>
        <TemperatureSlider saveAssistant={saveValue} />
        {/* <AssistantFunctionBlock
          asstId={assistantValue?.assistant_object?.id as string}
          saveAssistant={saveValue}
          handleOpenModal={handleOpenModal}
          handleCloseModal={handleCloseModal}
        /> */}
      </div>
      <GeneratePromptModal
        saveAssistant={saveValue}
        closeModal={handleCloseModal}
      />
      <AgentAssistantsModal closeModal={handleCloseModal} />
    </div>
  );
};
